import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import {
  Box,
  Container,
  HStack,
  Button,
  Text,
  Dialog,
  Icon,
  Tooltip,
  VStack
} from '@chakra-ui/react'
import { FiAlertCircle } from 'react-icons/fi'
import { Logo } from '../Brand/Logo'

export const WizardHeader: React.FC = () => {
  const navigate = useNavigate()
  const [isExitDialogOpen, setIsExitDialogOpen] = useState(false)

  const handleExit = () => {
    setIsExitDialogOpen(true)
  }

  const handleConfirmExit = () => {
    setIsExitDialogOpen(false)
    navigate('/')
  }

  return (
    <Box
      as="nav"
      bg="white"
      borderBottom="1px solid"
      borderColor="gray.100"
      position="sticky"
      top={0}
      zIndex={1000}
      py={3}
    >
      <Container maxW="5xl">
        <HStack justify="space-between" align="center">
          {/* Logo */}
          <Link to="/" style={{ textDecoration: 'none' }}>
            <HStack gap={3} align="center">
              <Logo size="md" />
              <Box height="24px" width="1px" bg="gray.300" transform="rotate(15deg)" />
              <Text fontSize="xl" fontWeight="medium" color="gray.500" letterSpacing="tight" mt={1}>
                Spotlight
              </Text>
            </HStack>
          </Link>

          {/* Exit Button */}
          <Tooltip.Root closeDelay={300} openDelay={200}>
            <Tooltip.Trigger asChild>
              <Button
                variant="ghost"
                size="sm"
                color="gray.600"
                onClick={handleExit}
                _hover={{ bg: 'gray.50', color: 'gray.800' }}
              >
                Exit
              </Button>
            </Tooltip.Trigger>
            <Tooltip.Positioner>
              <Tooltip.Content
                bg="gray.900"
                color="white"
                px={3}
                py={2}
                borderRadius="md"
                fontSize="sm"
                maxW="280px"
              >
                <Tooltip.Arrow>
                  <Tooltip.ArrowTip fill="gray.900" />
                </Tooltip.Arrow>
                Save your progress and exit onboarding. You can continue later from where you left off.
              </Tooltip.Content>
            </Tooltip.Positioner>
          </Tooltip.Root>
        </HStack>
      </Container>

      {/* Exit Confirmation Dialog */}
      <Dialog.Root open={isExitDialogOpen} onOpenChange={(e) => setIsExitDialogOpen(e.open)}>
        <Dialog.Backdrop bg="blackAlpha.600" />
        <Dialog.Positioner>
          <Dialog.Content maxW="md" bg="white" borderRadius="xl" boxShadow="xl" p={2}>
            <Dialog.Header pb={4}>
              <HStack gap={3}>
                <Icon as={FiAlertCircle} boxSize={5} color="brand.600" />
                <Dialog.Title fontSize="lg" fontWeight="semibold">
                  Exit Onboarding?
                </Dialog.Title>
              </HStack>
            </Dialog.Header>
            <Dialog.Body py={4}>
              <VStack align="stretch" gap={3}>
                <Text color="gray.600" fontSize="sm" lineHeight="tall">
                  Your progress will be automatically saved. You can return to complete onboarding at any time from your dashboard.
                </Text>
                <Box bg="blue.50" p={3} borderRadius="md" borderWidth="1px" borderColor="blue.200">
                  <Text fontSize="xs" color="blue.700" fontWeight="medium" mb={2}>
                    What happens next:
                  </Text>
                  <VStack align="stretch" gap={1}>
                    <Text fontSize="xs" color="blue.600">
                      • All your answers and progress are saved automatically
                    </Text>
                    <Text fontSize="xs" color="blue.600">
                      • You'll return to the home page
                    </Text>
                    <Text fontSize="xs" color="blue.600">
                      • Resume onboarding anytime from your dashboard
                    </Text>
                  </VStack>
                </Box>
              </VStack>
            </Dialog.Body>
            <Dialog.Footer gap={3}>
              <Button 
                variant="ghost" 
                onClick={() => setIsExitDialogOpen(false)}
                color="gray.700"
                _hover={{ bg: 'gray.50' }}
              >
                Cancel
              </Button>
              <Button 
                colorPalette="brand" 
                onClick={handleConfirmExit}
              >
                Save & Exit
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Dialog.Root>
    </Box>
  )
}


